/** Normalizes a keystroke in a hex color field into a displayable draft.
 *  Returns the draft ('#'-prefixed, up to 8 hex digits) or null when the raw
 *  text contains characters that can never form a hex color — the caller
 *  should ignore that keystroke and keep the previous draft. */
export function sanitizeHexDraft(raw: string): string | null {
  const digits = raw.startsWith('#') ? raw.slice(1) : raw;
  if (!/^[0-9A-Fa-f]{0,8}$/.test(digits)) return null;
  return `#${digits}`;
}

/** Returns the committable color when a draft is a complete #RRGGBB or
 *  #RRGGBBAA value (lowercased, matching what a native color input emits),
 *  or null while the draft is still incomplete. */
export function completeHexColor(draft: string): string | null {
  if (!/^#(?:[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(draft)) return null;
  return draft.toLowerCase();
}
